import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  label: {
    defaultMessage: 'Width (px)',
    id: '2Ge3CR',
    description: 'Label for width input',
  },
});
